import { render, staticRenderFns } from "./AssetsSummary.vue?vue&type=template&id=28a564ae&scoped=true"
import script from "./AssetsSummary.vue?vue&type=script&lang=js"
export * from "./AssetsSummary.vue?vue&type=script&lang=js"
import style0 from "./AssetsSummary.vue?vue&type=style&index=0&id=28a564ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a564ae",
  null
  
)

export default component.exports